import { FinishedExamModalView } from "src/components/Modals/FinishExamModals/FinishedExamModalView";
import { UnfinishedExamModalView } from "src/components/Modals/FinishExamModals/UnfinishedExamModalView";
import { useGetExam } from "src/hooks/useExam";
import { ExamStatus } from "src/types/enums";

interface FinishExamModalProps {
	examId: string;
	onClose: () => void;
}

export const FinishExamModal = ({ examId, onClose }: FinishExamModalProps) => {
	const { data, isLoading } = useGetExam(examId);

	if (isLoading) {
		return null;
	}

	if (data.status === ExamStatus.FINISHED) {
		return <FinishedExamModalView exam={data} onClose={onClose} />;
	}

	return <UnfinishedExamModalView exam={data} onClose={onClose} />;
};
